import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { map, catchError, exhaustMap } from 'rxjs/operators';
import * as actions from '@appStore/app/actions';
import { ActionTypes } from '@appStore/app/actions';
import { TipService } from '@appStore/app/services';

@Injectable()
export class TipEffects {
    constructor(private actions$: Actions, private tipService: TipService) {}

    getTips$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(ActionTypes.TipsLoad),
            exhaustMap((action: actions.TipsLoad) => {
                return this.tipService.getTips().pipe(
                    map(tips => new actions.TipsLoadSuccess(tips)),
                    catchError(error => of(new actions.TipsLoadFail(error)))
                );
            })
        );
    });

    setAsRead$ = createEffect(() =>{
        return this.actions$.pipe(
            ofType(ActionTypes.TipSetAsRead),
            exhaustMap((action: actions.TipSetAsRead)=> {
                return this.tipService.setAsRead(action.payload).pipe(
                    map(tip => new actions.TipSetAsReadSuccess(tip)),
                    catchError(error => of(new actions.TipSetAsReadFail(error)))
                )
            })
        );
    });
}